export default __webpack_public_path__ + "static/media/AdBlueEsso_can.436d0bd1.svg";